import { __callbacks } from "Utils/Callbacks/Callback";
import { useCallback, useEffect, useRef } from "react";
import styles from "./Input.module.scss";

export default function Input() {

  const textArea = useRef(null);


  const handleChatbutton = useCallback(
    (enable) => {
      if(enable) {
        __callbacks.chatSendButton.trigger({enable: true});
      }
      else {
        __callbacks.chatSendButton.trigger({enable: false});
      }
    },
    [],
  );

  const handleChatInput = useCallback(
    () => {
      textArea.current.style.setProperty("height", "0");
      textArea.current.style.setProperty("height", `${textArea.current.scrollHeight}px`);
      

      // handle chat button enabling and desabling
      const isEmpty = (textArea.current.value.trim() === "");

      if(isEmpty) {
        handleChatbutton(false);
      }
      else {
        handleChatbutton(true);
      }
    },
    [handleChatbutton],
  );
  
  

  const submit = useCallback(
    () => {
      const textAreaValue = textArea.current.value;
      textArea.current.style.setProperty("height", "0");
      __callbacks.chatInputSubmit.trigger({
        textAreaValue,
        userSubmit: true
      });
      textArea.current.value = "";
      
      // disable chat send button
      __callbacks.chatSendButton.trigger({enable: false});
    },
    [],
  );

  const handleSubmit = useCallback(
    (e) => {
      const isEmpty = (textArea.current.value.trim() === "");
      if ( e.keyCode === 13 && (!isEmpty) ) {
        if (!e.shiftKey) {
          e.preventDefault();
          submit();
        }
      }

    },
    [submit],
  );
  const initEvents = useCallback(
    () => {
      textArea.current.addEventListener("keydown", e => {
        handleSubmit(e);
      });

      textArea.current.addEventListener("input", e => {
        handleChatInput();
      });

      __callbacks.onFocusChatInput(() => {
        textArea.current.focus();
      });
      __callbacks.onBlurChatInput(() => {
        textArea.current.blur();
      });
      __callbacks.onResetChatInputs(value => {
        if(value) {
          textArea.current.value = "";
        }
      });
      __callbacks.onAppendChatInput(text => {
        textArea.current.value += text;
        handleChatInput();
      });

      __callbacks.onChatSendButtonClick(() => {
        submit();
      });

    },
    [handleSubmit, submit, handleChatInput]
  );


  useEffect(() => {
    initEvents();
  }, [initEvents]);


  return (
    <div className={styles.container}>
      <textarea ref={textArea} name="chat-input" id="" cols="30" rows="10" placeholder="Message..." aria-label="Message..." spellCheck="true" maxLength="4096" autoFocus={true}></textarea>
    </div>
  )
}
